import {
  VStack,
  HStack,
  Heading,
  Text,
  Card,
  CodeBlock,
  InlineCode,
  Divider,
  Badge,
  TableOfContents,
  Animate,
  useIsDesktop
} from 'wss3-forge'

export function DocsApi() {
  const isDesktop = useIsDesktop()
  const apiUrl = 'https://zfdxudjuhrvezrfezkml.supabase.co/functions/v1'

  const tocItems = [
    { id: 'auth-token', title: 'POST /auth-token' },
    { id: 'auth-refresh', title: 'POST /auth-refresh' },
    { id: 'auth-revoke', title: 'POST /auth-revoke' },
    { id: 'auth-userinfo', title: 'GET /auth-userinfo' },
    { id: 'auth-verify', title: 'POST /auth-verify' },
    { id: 'auth-profile', title: 'GET/PUT /auth-profile' },
    { id: 'org-list', title: 'GET /org-list' },
    { id: 'org-get', title: 'GET /org-get' },
    { id: 'org-create', title: 'POST /org-create' },
    { id: 'org-update', title: 'PATCH /org-update' },
    { id: 'org-delete', title: 'DELETE /org-delete' },
    { id: 'org-members', title: 'GET/PATCH/DEL /org-members' },
    { id: 'org-member-invite', title: 'POST /org-member-invite' }
  ]

  return (
    <div className="page-content">
      <HStack gap="xl" style={{ alignItems: 'flex-start' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <VStack gap="xl">
            <Animate type="fadeIn">
              <VStack gap="sm" style={{ alignItems: 'flex-start' }}>
                <Badge variant="primary">API</Badge>
                <Heading level={1}>Référence API</Heading>
                <Text color="muted" size="lg">
                  Documentation complète des endpoints de l'API Webba ID.
                </Text>
                <Text color="muted">Base URL : <InlineCode>{apiUrl}</InlineCode></Text>
              </VStack>
            </Animate>

            {/* auth-token */}
            <div id="auth-token" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={100}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="primary">POST</Badge>
                      <Heading level={3}>/auth-token</Heading>
                    </HStack>
                    <Text color="muted">Échange un code d'autorisation contre un token d'accès.</Text>

                    <Divider />

                    <Text weight="medium">Requete :</Text>
                    <CodeBlock
                      code={`{
  "code": "string",
  "app_key": "wba_xxx",
  "app_secret": "wbs_xxx",
  "redirect_uri": "https://yourapp.com/auth/callback",
  "code_verifier": "string"  // PKCE - requis
}`}
                      language="json"
                    />

                    <Text weight="medium">Reponse :</Text>
                    <CodeBlock
                      code={`{
  "access_token": "wbt_...",
  "refresh_token": "wbr_...",
  "token_type": "Bearer",
  "expires_in": 3600,
  "user_id": "uuid"
}`}
                      language="json"
                    />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Erreurs possibles :</Text>
                        <Text size="sm"><Badge size="sm" variant="error">400</Badge> Code invalide ou expiré</Text>
                        <Text size="sm"><Badge size="sm" variant="error">401</Badge> App key ou secret invalide</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* auth-refresh */}
            <div id="auth-refresh" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={125}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="primary">POST</Badge>
                      <Heading level={3}>/auth-refresh</Heading>
                    </HStack>
                    <Text color="muted">Rafraichit un access_token expire en utilisant le refresh_token.</Text>

                    <Divider />

                    <Text weight="medium">Requete :</Text>
                    <CodeBlock code={`{
  "refresh_token": "wbr_...",
  "app_key": "wba_xxx"
}`} language="json" />

                    <Text weight="medium">Reponse :</Text>
                    <CodeBlock code={`{
  "access_token": "wbt_...",
  "refresh_token": "wbr_...",  // Nouveau refresh_token
  "token_type": "Bearer",
  "expires_in": 3600,
  "user_id": "uuid"
}`} language="json" />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Important :</Text>
                        <Text size="sm">Le refresh_token est a usage unique (rotation).</Text>
                        <Text size="sm">Stockez toujours le nouveau refresh_token retourne.</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* auth-revoke */}
            <div id="auth-revoke" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={135}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="primary">POST</Badge>
                      <Heading level={3}>/auth-revoke</Heading>
                    </HStack>
                    <Text color="muted">Revoque un token (deconnexion).</Text>

                    <Divider />

                    <Text weight="medium">Requete :</Text>
                    <CodeBlock code={`{
  "token": "wbt_... ou wbr_...",
  "app_key": "wba_xxx"
}`} language="json" />

                    <Text weight="medium">Reponse :</Text>
                    <CodeBlock code={`{
  "success": true
}`} language="json" />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Note :</Text>
                        <Text size="sm">Revoquer l'access_token revoque aussi le refresh_token associe.</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* auth-userinfo */}
            <div id="auth-userinfo" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={150}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="success">GET</Badge>
                      <Heading level={3}>/auth-userinfo</Heading>
                    </HStack>
                    <Text color="muted">Récupère les informations de base de l'utilisateur.</Text>

                    <Divider />

                    <Text weight="medium">Query params :</Text>
                    <CodeBlock code={`app_key=wba_xxx
access_token=wbt_xxx
include_profile=true  # optionnel`} language="http" />

                    <Text weight="medium">Headers (authentication API) :</Text>
                    <CodeBlock code={`Authorization: Bearer <webba_id_supabase_anon_key>
apikey: <webba_id_supabase_anon_key>`} language="http" />

                    <Text weight="medium">Réponse :</Text>
                    <CodeBlock code={`{
  "user_id": "uuid",
  "email": "user@example.com",
  "app_id": "uuid"
}`} language="json" />

                    <Text weight="medium">Réponse avec <InlineCode>include_profile=true</InlineCode> :</Text>
                    <CodeBlock code={`{
  "user_id": "uuid",
  "email": "user@example.com",
  "app_id": "uuid",
  "profile": {
    "first_name": "John",
    "display_name": "johndoe",
    "avatar_url": "https://..."
  },
  "subscriptions": [
    { "plan": "pro", "status": "active" }
  ]
}`} language="json" />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Erreurs possibles :</Text>
                        <Text size="sm"><Badge size="sm" variant="error">400</Badge> app_key manquant</Text>
                        <Text size="sm"><Badge size="sm" variant="error">401</Badge> Token invalide ou expiré</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* auth-verify */}
            <div id="auth-verify" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={200}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="primary">POST</Badge>
                      <Heading level={3}>/auth-verify</Heading>
                    </HStack>
                    <Text color="muted">Vérifie si un token est valide.</Text>

                    <Divider />

                    <Text weight="medium">Requête :</Text>
                    <CodeBlock code={`{
  "token": "string",
  "app_key": "string"
}`} language="json" />

                    <Text weight="medium">Réponse (valide) :</Text>
                    <CodeBlock code={`{
  "valid": true,
  "user_id": "uuid",
  "email": "user@example.com"
}`} language="json" />

                    <Text weight="medium">Réponse (invalide) :</Text>
                    <CodeBlock code={`{
  "valid": false,
  "error": "Token expired"
}`} language="json" />
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* auth-profile */}
            <div id="auth-profile" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={250}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="success">GET</Badge>
                      <Badge variant="warning">PUT</Badge>
                      <Heading level={3}>/auth-profile</Heading>
                    </HStack>
                    <Text color="muted">Récupère ou met à jour le profil complet de l'utilisateur.</Text>

                    <Divider />

                    <Text weight="medium">Headers :</Text>
                    <CodeBlock code={`Authorization: Bearer <access_token>`} language="http" />

                    <Text weight="medium">Query params :</Text>
                    <CodeBlock code={`app_key=wba_votre_app_key`} language="http" />

                    <Text weight="medium">Réponse GET :</Text>
                    <CodeBlock code={`{
  "user_id": "uuid",
  "email": "user@example.com",
  "email_verified": true,
  "profile": {
    "first_name": "John",
    "last_name": "Doe",
    "display_name": "johndoe",
    "avatar_url": "https://...",
    "phone": "+33612345678",
    "locale": "fr",
    "timezone": "Europe/Paris",
    "theme": "dark"
  },
  "subscriptions": [...],
  "roles": [
    { "role": "admin", "app_id": "uuid" }
  ]
}`} language="json" />

                    <Divider />

                    <Text weight="medium">Requête PUT (champs modifiables) :</Text>
                    <CodeBlock code={`{
  "first_name": "string",
  "last_name": "string",
  "display_name": "string",
  "avatar_url": "string",
  "date_of_birth": "YYYY-MM-DD",
  "phone": "string",
  "address_line1": "string",
  "city": "string",
  "postal_code": "string",
  "country": "FR",
  "locale": "fr",
  "timezone": "Europe/Paris",
  "theme": "dark"
}`} language="json" />

                    <Text weight="medium">Réponse PUT :</Text>
                    <CodeBlock code={`{
  "success": true,
  "profile": { ... }
}`} language="json" />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Erreurs possibles :</Text>
                        <Text size="sm"><Badge size="sm" variant="error">400</Badge> Aucun champ valide à mettre à jour</Text>
                        <Text size="sm"><Badge size="sm" variant="error">401</Badge> Token invalide ou expiré</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* Organizations Section Header */}
            <Animate type="fadeIn" delay={275}>
              <Divider />
              <VStack gap="xs" style={{ alignItems: 'flex-start' }}>
                <Badge variant="default">Organizations API</Badge>
                <Text color="muted">Endpoints pour gerer les organisations et leurs membres.</Text>
              </VStack>
            </Animate>

            {/* org-list */}
            <div id="org-list" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={300}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="success">GET</Badge>
                      <Heading level={3}>/org-list</Heading>
                    </HStack>
                    <Text color="muted">Liste les organisations dont l'utilisateur est membre.</Text>

                    <Divider />

                    <Text weight="medium">Query params :</Text>
                    <CodeBlock code={`app_key=wba_xxx
access_token=wbt_xxx`} language="http" />

                    <Text weight="medium">Reponse :</Text>
                    <CodeBlock code={`{
  "organizations": [
    {
      "id": "uuid",
      "name": "My Company",
      "slug": "my-company",
      "logo_url": "https://...",
      "is_active": true,
      "created_at": "2025-01-01T00:00:00Z",
      "role": "owner",
      "joined_at": "2025-01-01T00:00:00Z",
      "members_count": 5,
      "domains_count": 2
    }
  ]
}`} language="json" />
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* org-get */}
            <div id="org-get" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={325}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="success">GET</Badge>
                      <Heading level={3}>/org-get</Heading>
                    </HStack>
                    <Text color="muted">Recupere les details d'une organisation.</Text>

                    <Divider />

                    <Text weight="medium">Query params :</Text>
                    <CodeBlock code={`app_key=wba_xxx
access_token=wbt_xxx
org_id=uuid`} language="http" />

                    <Text weight="medium">Reponse :</Text>
                    <CodeBlock code={`{
  "organization": {
    "id": "uuid",
    "name": "My Company",
    "slug": "my-company",
    "logo_url": "https://...",
    "is_active": true,
    "role": "owner",
    "domains": [
      { "id": "uuid", "domain": "company.com", "verified": true }
    ],
    "members_count": 5,
    "sso_connections_count": 1
  }
}`} language="json" />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Erreurs :</Text>
                        <Text size="sm"><Badge size="sm" variant="error">403</Badge> Non membre de l'organisation</Text>
                        <Text size="sm"><Badge size="sm" variant="error">404</Badge> Organisation non trouvee</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* org-create */}
            <div id="org-create" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={350}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="primary">POST</Badge>
                      <Heading level={3}>/org-create</Heading>
                    </HStack>
                    <Text color="muted">Cree une nouvelle organisation. L'utilisateur devient owner.</Text>

                    <Divider />

                    <Text weight="medium">Headers :</Text>
                    <CodeBlock code={`X-Access-Token: wbt_xxx
# ou Authorization: Bearer wbt_xxx`} language="http" />

                    <Text weight="medium">Requete :</Text>
                    <CodeBlock code={`{
  "app_key": "wba_xxx",
  "name": "My Company",
  "slug": "my-company",    // optionnel, genere auto
  "logo_url": "https://..."  // optionnel
}`} language="json" />

                    <Text weight="medium">Reponse (201) :</Text>
                    <CodeBlock code={`{
  "organization": {
    "id": "uuid",
    "name": "My Company",
    "slug": "my-company",
    "role": "owner",
    "members_count": 1,
    "domains_count": 0
  }
}`} language="json" />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Erreurs :</Text>
                        <Text size="sm"><Badge size="sm" variant="error">409</Badge> Slug deja utilise</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* org-update */}
            <div id="org-update" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={375}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="warning">PATCH</Badge>
                      <Heading level={3}>/org-update</Heading>
                    </HStack>
                    <Text color="muted">Met a jour une organisation. Requiert role owner ou admin.</Text>

                    <Divider />

                    <Text weight="medium">Headers :</Text>
                    <CodeBlock code={`X-Access-Token: wbt_xxx`} language="http" />

                    <Text weight="medium">Requete :</Text>
                    <CodeBlock code={`{
  "app_key": "wba_xxx",
  "org_id": "uuid",
  "name": "New Name",       // optionnel
  "slug": "new-slug",       // optionnel
  "logo_url": "https://...", // optionnel
  "is_active": true          // optionnel
}`} language="json" />

                    <Text weight="medium">Reponse :</Text>
                    <CodeBlock code={`{
  "organization": { ... }
}`} language="json" />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Erreurs :</Text>
                        <Text size="sm"><Badge size="sm" variant="error">403</Badge> Permission insuffisante</Text>
                        <Text size="sm"><Badge size="sm" variant="error">409</Badge> Slug deja utilise</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* org-delete */}
            <div id="org-delete" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={400}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="error">DELETE</Badge>
                      <Heading level={3}>/org-delete</Heading>
                    </HStack>
                    <Text color="muted">Supprime une organisation et toutes ses donnees. Requiert role owner.</Text>

                    <Divider />

                    <Text weight="medium">Headers :</Text>
                    <CodeBlock code={`X-Access-Token: wbt_xxx`} language="http" />

                    <Text weight="medium">Query params :</Text>
                    <CodeBlock code={`app_key=wba_xxx
org_id=uuid`} language="http" />

                    <Text weight="medium">Reponse :</Text>
                    <CodeBlock code={`{
  "success": true
}`} language="json" />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Attention :</Text>
                        <Text size="sm">Supprime aussi : membres, domaines, connexions SSO</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* org-members */}
            <div id="org-members" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={425}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="success">GET</Badge>
                      <Badge variant="warning">PATCH</Badge>
                      <Badge variant="error">DELETE</Badge>
                      <Heading level={3}>/org-members</Heading>
                    </HStack>
                    <Text color="muted">Gere les membres d'une organisation.</Text>

                    <Divider />

                    <Text weight="medium">GET - Lister les membres :</Text>
                    <CodeBlock code={`GET /org-members?app_key=wba_xxx&access_token=wbt_xxx&org_id=uuid`} language="http" />
                    <CodeBlock code={`{
  "members": [
    {
      "id": "uuid",
      "user_id": "uuid",
      "role": "admin",
      "created_via": "invite",
      "email": "user@example.com",
      "profile": {
        "first_name": "John",
        "display_name": "johndoe",
        "avatar_url": "https://..."
      }
    }
  ]
}`} language="json" />

                    <Divider />

                    <Text weight="medium">PATCH - Modifier le role (owner only) :</Text>
                    <CodeBlock code={`PATCH /org-members?app_key=wba_xxx&org_id=uuid
X-Access-Token: wbt_xxx

{
  "member_id": "uuid",
  "role": "admin"  // admin | sso_admin | viewer | member
}`} language="http" />

                    <Divider />

                    <Text weight="medium">DELETE - Retirer un membre :</Text>
                    <CodeBlock code={`DELETE /org-members?app_key=wba_xxx&org_id=uuid&member_id=uuid
X-Access-Token: wbt_xxx`} language="http" />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Permissions :</Text>
                        <Text size="sm">GET : tout membre · PATCH : owner · DELETE : owner/admin ou soi-meme</Text>
                        <Text size="sm">Le owner ne peut pas etre retire</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

            {/* org-member-invite */}
            <div id="org-member-invite" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={450}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Badge variant="primary">POST</Badge>
                      <Heading level={3}>/org-member-invite</Heading>
                    </HStack>
                    <Text color="muted">Invite un nouveau membre par email. Requiert role owner ou admin.</Text>

                    <Divider />

                    <Text weight="medium">Headers :</Text>
                    <CodeBlock code={`X-Access-Token: wbt_xxx`} language="http" />

                    <Text weight="medium">Requete :</Text>
                    <CodeBlock code={`{
  "app_key": "wba_xxx",
  "org_id": "uuid",
  "email": "newuser@example.com",
  "role": "member"  // admin | sso_admin | viewer | member
}`} language="json" />

                    <Text weight="medium">Reponse (201) :</Text>
                    <CodeBlock code={`{
  "member": {
    "id": "uuid",
    "organization_id": "uuid",
    "user_id": null,  // null jusqu'a acceptation
    "role": "member",
    "invite_email": "newuser@example.com",
    "invite_sent_at": "2025-01-01T00:00:00Z",
    "organization_name": "My Company"
  },
  "invite_token": "uuid"  // pour le lien d'invitation
}`} language="json" />

                    <Card variant="subtle" padding="md">
                      <VStack gap="xs">
                        <Text size="sm" weight="medium">Erreurs :</Text>
                        <Text size="sm"><Badge size="sm" variant="error">409</Badge> Email deja invite ou membre</Text>
                        <Text size="sm"><Badge size="sm" variant="error">403</Badge> Permission insuffisante</Text>
                      </VStack>
                    </Card>
                  </VStack>
                </Card>
              </Animate>
            </div>

          </VStack>
        </div>

        {isDesktop && (
          <div style={{
            position: 'sticky',
            top: '2rem',
            width: '220px',
            flexShrink: 0
          }}>
            <TableOfContents
              items={tocItems}
              title="Endpoints"
              autoTrack
              scrollOffset={100}
              variant="bordered"
            />
          </div>
        )}
      </HStack>
    </div>
  )
}
